(() => {
  const applyColour = (button) => {
    const card = button.closest('.arv-design-card, .card-wrapper');
    if (!card) return;
    const group = button.closest('.arv-color-swatches');
    if (group) {
      for (const other of group.querySelectorAll('[data-arv-color-swatch]')) {
        const selected = other === button;
        other.classList.toggle('is-selected', selected);
        other.setAttribute('aria-pressed', selected ? 'true' : 'false');
      }
    }
    const photo = card.querySelector('.arv-design-card__image img, .card__media img');
    if (photo && button.dataset.arvImageSrc) {
      photo.src = button.dataset.arvImageSrc;
      if (button.dataset.arvImageSrcset) photo.srcset = button.dataset.arvImageSrcset;
      if (button.dataset.arvImageAlt) photo.alt = button.dataset.arvImageAlt;
    }
    if (button.dataset.arvVariantUrl) {
      for (const anchor of card.querySelectorAll('.arv-design-card__link, a.full-unstyled-link')) {
        anchor.setAttribute('href', button.dataset.arvVariantUrl);
      }
    }
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-arv-color-swatch]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    applyColour(button);
  });
  const init = () => {
    for (const root of document.querySelectorAll('[data-arv-design-root]')) {
      const currentUrl = new URL(window.location.href);
      const params = currentUrl.searchParams;
      const type = params.get('filter.p.product_type');
      const view = params.get('arv_view');
      const preview = params.get('preview_theme_id');
      for (const tab of root.querySelectorAll('a[data-arv-design-tab]')) {
        const href = new URL(tab.href, currentUrl);
        if (preview) href.searchParams.set('preview_theme_id', preview);
        tab.href = href.toString();
        const key = tab.getAttribute('data-arv-design-tab');
        const selected = view === 'all' ? key === 'all' :
          type === 'Jumpsuit' ? key === 'jumpsuit' :
          type === 'T-shirt' ? key === 'tshirt' :
          type === 'Romper' ? key === 'designs' :
          key === 'all';
        tab.classList.toggle('is-active', selected);
        if (selected) tab.setAttribute('aria-current', 'page');
        else tab.removeAttribute('aria-current');
      }
      if (root.dataset.arvDesignReady !== 'true') continue;
      if (type || view) continue;
      if (Array.from(params.keys()).some(key => key.startsWith('filter.'))) continue;
      const link = root.querySelector('a[data-arv-design-tab="designs"]');
      if (!link) continue;
      const to = new URL(link.href, currentUrl);
      for (const key of ['preview_theme_id', 'sort_by']) {
        if (params.has(key)) to.searchParams.set(key, params.get(key));
      }
      window.location.replace(to.toString());
      return;
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();